import { createSelector } from 'reselect';
import { selectors as sessionSelectors } from '@clearscore/redux.session';
import roles from '@clearscore/constants.role-statuses';

import routesSelector from './routesSelector';

const getRoutesRole = ({ userRole }) => {
    if (userRole === roles.AUTHORISED) {
        return roles.AUTHORISED;
    } else if (userRole === roles.PROSPECT) {
        return roles.PROSPECT;
    } else if (userRole === roles.PENDING) {
        return roles.PENDING;
    }
    return roles.UNAUTHORISED;
};

export default createSelector(routesSelector, sessionSelectors.getAuthRole, (routes, userRole) => {
    const loggedOut = userRole === roles.UNAUTHORISED;
    const isProspect = userRole === roles.PROSPECT;
    const isPending = userRole === roles.PENDING;
    const loggedIn = userRole === roles.AUTHORISED;
    const userRoutes = routes.filter((route) => {
        // TODO: We should add `isPending` role to the relevant routes render-engine config
        if (isPending && route.path.includes('login')) return true;

        return route.role.includes(getRoutesRole({ userRole }));
    });

    return { routes: userRoutes, loggedIn, loggedOut, isProspect, isPending };
});
